<template>
  <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 610px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <l-map
          ref="mymap"
          :zoom="zoom"
          style="width: 100%; height: 560px; z-index: 0"
          :center="center"
          :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
        >
          <l-tile-layer :url="url" />
          <l-marker
            v-for="(marker, index) in markers"
            :key="'marker'+index"
            :ref="'marker'+index"
            :lat-lng="getValidLatLng(marker.Latitude, marker.Longitude)"
            :options="{ autoClose: false, closeOnClick: false }"
            @click="stream(marker.RTSP_HLS, marker.Camera_Desc)"
          >
            <l-icon
              :icon-size="[28, 40]"
              :icon-anchor="[16, 37]"
              :icon-url="require('@/assets/images/icons/MakerCCTV.svg')"
            />
            <l-popup
              ref="popup"
            >
              <div>
                <span style="color:white; padding: 1px; text-align: left; font-size:14px;">
                  ตำแหน่ง:{{ camdesc }}
                </span>
                <video
                  id="video"
                  style="width:250px; height:auto; flex-direction: row;"
                  muted
                  autoplay
                  playsinline
                />
              </div>
            </l-popup>
          </l-marker>
        </l-map>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BCard,
  // BTable, BButton
} from 'bootstrap-vue'
import Hls from 'hls.js'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    // BTable,
    // BButton,
    BCard,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 6,
      center: [13.764934616104194, 100.53828892428231],
      waydetail: '',
      markers: [],
      check: false,
      fields: [
        { key: 'detail', label: 'จุดติดตั้ง:', class: 'text-center' },
        { key: 'id', label: '', class: 'text-center' },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
      itemsCount: [],
      camdesc: '',
    }
  },
  created() {
    this.getMarkerCCTV()
    if (this.userData.department !== '0') {
      this.zoom = 10
    }
  },
  mounted() {
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())
  },
  methods: {
    getValidLatLng(lat, lng) {
      // ตรวจสอบและแปลงค่าพิกัดให้ถูกต้อง
      try {
        // แปลงค่าเป็น string ก่อนเพื่อจัดการกับรูปแบบที่อาจมีปัญหา
        const latStr = String(lat).trim().replace(/,/g, '.')
        const lngStr = String(lng).trim().replace(/,/g, '.')

        // แปลงเป็นตัวเลข
        const latitude = parseFloat(latStr)
        const longitude = parseFloat(lngStr)

        // ตรวจสอบว่าเป็นตัวเลขที่ถูกต้องหรือไม่
        if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
          console.log('Invalid coordinates:', lat, lng)
          return [13.736717, 100.523186] // ค่าเริ่มต้นถ้าพิกัดไม่ถูกต้อง (กรุงเทพฯ)
        }

        return [latitude, longitude]
      } catch (error) {
        console.log('Error parsing coordinates:', error)
        return [13.736717, 100.523186] // ค่าเริ่มต้นถ้าเกิดข้อผิดพลาด
      }
    },
    getMarkerCCTV() {
      axios
        .post('/getMarkerCCTVDB', { department: this.userData.department, owner: this.userData.groupname })
        .then(response => {
          if (this.userData.department !== '0') {
            this.center.splice(0)
            this.center.push(response.data[0].Latitude)
            this.center.push(response.data[0].Longitude)
          }
          this.markers = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    stream(value, camdesc) {
      setTimeout(() => {
        this.camdesc = camdesc
        const hls = new Hls({
          lowLatencyMode: true,
          autoreconnect: true,
        })
        const stream = value
        const video = document.querySelector('#video')
        hls.loadSource(stream)
        hls.attachMedia(video)
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
        hls.on(Hls.Events.ERROR, () => {
          video.play()
        })
      }, 500)
    },
  },
}
</script>

<style >
.leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.85);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}
</style>
